import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormHelperText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import { useDispatch } from "react-redux";

import Search from "@mui/icons-material/Search";

import { useFormik } from 'formik';
import * as yup from 'yup';

import { DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import * as Util from "../../services/global.service";

import {
  getAchievementAdd
} from "../../actions/achievement";

const useStyles = makeStyles({
  "error": {
    color: " #CC6058 !important",
    position: "relative",
    marginBottom: "14px !important",
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "21.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "21.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  "errorDis": {
    color: " #CC6058 !important",
    position: "relative",
    marginBottom: "14px !important",
    "&  > div > div ": {
      backgroundColor: "#F5F5F5 !important",
    },
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  "autocomplete-root": {
    backgroundColor: `${cssVariables.color.primary}!important`,
    borderRadius: '4px!important',
    color: '#fff!important',
  },
  "autocomplete-remove-icon": {
    fontSize: '1.2rem!important',
    lineHeight: 1.5
  },
  footer: {
    position: "sticky",
    bottom: "-20px",
    background: "white",
    paddingTop: "20px",
    paddingBottom: "15px",
  },
  disabled: {
    background: "#F3F3F3!important"
  },
  softDisabled: {
    background: "#FAFAFA!important"
  },
  checkboxRoot: {
    paddingTop: "1px!important"
  },
  formControlRoot: {
    alignItems: "flex-start!important"
  }
});

const InputForm = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [metricList, setMetricList] = React.useState([]);
  const [currentMetric, setCurrentMetric] = React.useState({});
  const [metricConditionList, setMetricConditionList] = React.useState([]);
  const [metricConditionListMaster, setMetricConditionListMaster] = React.useState([]);
  const [metricUnitList, setMetricUnitList] = React.useState([]);
  const [metricUnitListMaster, setMetricUnitListMaster] = React.useState([]);
  const [metricUnitOptions, setMetricUnitOptions] = React.useState({ min: 0 });
  const [metricValue, setMetricValue] = React.useState("");
  const [metricValueList, setMetricValueList] = React.useState([]);
  const [metricValueListMaster, setMetricValueListMaster] = React.useState([]);
  const [goalList, setGoalList] = React.useState([]);
  const [competencyList, setCompetencyList] = React.useState([]);
  const [filteredGoalList, setFilteredGoalList] = React.useState([]);
  const [filteredCompetencyList, setFilteredCompetencyList] = React.useState([]);
  const [searchGoal, setSearchGoalValue] = React.useState("");
  const [searchCompetency, setSearchCompetencyValue] = React.useState("");
  const [minDate, setMinDate] = React.useState(Util.formatDate(new Date()));
  const [maxDate, setMaxDate] = React.useState(Util.formatDate(new Date()));
  const [maxEndDate, setMaxEndDate] = React.useState(Util.formatDate(new Date()));
  const [maxLink, setMaxLink] = React.useState(0);
  const [currentSelectedLink, setcurrentSelectedLink] = React.useState([]);
  const [isSelectedLinkValid, setIsSelectedLinkValid] = React.useState(true);

  const InitValidationSchema = yup.object({
    name: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
    description: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
    startDate: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
    endDate: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
    metric: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
    metricValue: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
  });
  const [validationSchema, setValidationSchema] = React.useState(InitValidationSchema);

  const formik = useFormik({
    initialValues: {
      achievementSerial: "",
      name: "",
      description: "",
      startDate: props.data.startDate ? Util.formatDate(props.data.startDate) : Util.formatDate(new Date()),
      endDate: props.data.endDate ? Util.formatDate(props.data.endDate) : Util.formatDate(Util.subStractDate(new Date(), "add", 1)),
      metric: "",
      metricCondition: "",
      metricUnit: "",
      metricValue: "",
      metricUnitCustom: "",
      isLink: false,
      selectedGoals: [],
      selectedCompetencies: [],
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (props.type === "add") {
        values.cycle = props.form
        props.submit(values)
      } else if (props.type === "edit") {
        values.cycle = props.form
        props.edit(values)
      }
    },
  });

  // on load
  useEffect(() => {
    let formSerial = ""
    if (props.form) formSerial = props.form
    dispatch(getAchievementAdd(formSerial)).then(resp => {
      let metricList = resp?.form ?? []
      let endAt = resp?.end_at ?? ""
      setMetricList(metricList)
      setMaxLink(resp.max_link ?? 0)

      let metricConditionList = []
      let metricUnitList = []
      let metricValueList = []
      metricList.forEach(element => {
        let unitObj = { serial: element.serial, code: element.code, list: [] }
        if (element.code === "value" && element.value !== undefined) {
          unitObj.list = element.value
        }
        let conditionObj = { serial: element.serial, list: [], type: "" }
        if (element.options !== undefined) {
          conditionObj.type = element.options?.type ?? ""
          if (element.options.target_condition !== undefined) {
            let conditionList = element.options.target_condition.map(option => {
              return {
                name: option.label,
                value: option.value
              }
            })
            conditionObj.list = conditionList
          }
        }
        metricConditionList.push(conditionObj)
        metricUnitList.push(unitObj)

        let valueObj = { serial: element.serial, list: [] }
        if (element.code !== "value" && element.value !== undefined) {
          valueObj.list = element.value
        }
        metricValueList.push(valueObj)
      });
      let splitDate = endAt.split("-")
      const endDate = new Date(`${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`)
      const currentDate = new Date()
      if (endDate.getTime() < currentDate.getTime()) {
        console.log("1")
        formik.setFieldValue("startDate", Util.formatDate(Util.subStractDate(endDate, "minus", 1)))
        formik.setFieldValue("endDate", Util.formatDate(endDate))
      } else {
        console.log("2")
        formik.setFieldValue("startDate", Util.formatDate(currentDate))
        formik.setFieldValue("endDate", Util.formatDate(Util.subStractDate(currentDate, "add", 1)))
      }
      setMaxEndDate(endDate)

      setMetricConditionListMaster(metricConditionList)
      setMetricUnitListMaster(metricUnitList)
      setMetricValueListMaster(metricValueList)

      // set goals and competencies
      let goalList = resp?.goals ?? []
      setGoalList(goalList)
      setFilteredGoalList(goalList)
      let competencyList = resp?.competencies ?? []
      setCompetencyList(competencyList)
      setFilteredCompetencyList(competencyList)
    })
  }, [])

  // search
  useEffect(() => {
    let result = [];
    if (searchGoal !== "") {
      result = [...goalList].filter((item) => {
        return item.name.toString().toLowerCase().indexOf(searchGoal) !== -1;
      })
    } else {
      result = [...goalList];
    }
    setFilteredGoalList(result)
  }, [searchGoal])

  useEffect(() => {
    let result = [];
    if (searchCompetency !== "") {
      result = [...competencyList].filter((item) => {
        return item.name.toString().toLowerCase().indexOf(searchCompetency) !== -1;
      })
    } else {
      result = [...competencyList];
    }
    setFilteredCompetencyList(result)
  }, [searchCompetency])

  useEffect(() => {
    const date = new Date(formik.values.startDate);
    date.setDate(date.getDate());
    setMinDate(date)
  }, [formik.values.startDate])
  useEffect(() => {
    const date = new Date(formik.values.endDate);
    date.setDate(date.getDate());
    setMaxDate(date)
  }, [formik.values.endDate])

  useEffect(() => {
    if (formik.values.metric !== "" && metricConditionListMaster.length > 0 && metricUnitListMaster.length > 0 && metricList.length > 0) {
      let metricConditionList = metricConditionListMaster.filter(item => item.serial === formik.values.metric)
      if (metricConditionList.length > 0) setMetricConditionList(metricConditionList[0].list)

      let metricUnitList = metricUnitListMaster.filter(item => item.serial === formik.values.metric)
      if (metricUnitList.length > 0) setMetricUnitList(metricUnitList[0].list)

      let tmpCurrentMetric = metricList.filter(item => item.serial === formik.values.metric)
      if (tmpCurrentMetric.length > 0) setCurrentMetric(tmpCurrentMetric[0])

    }
  }, [formik.values.metric, metricConditionListMaster, metricUnitListMaster, metricList])

  useEffect(() => {
    if (props.type === "edit") {
      // if (metricConditionListMaster.length > 0 && metricUnitListMaster.length > 0 &&  metricList.length > 0) {
      formik.setFieldValue("achievementSerial", props.data.achievementSerial)
      formik.setFieldValue("name", props.data.name)
      formik.setFieldValue("description", props.data.description)
      formik.setFieldValue("startDate", props.data.startDate ? Util.formatDate(props.data.startDate) : Util.formatDate(new Date()))
      formik.setFieldValue("endDate", props.data.endDate ? Util.formatDate(props.data.endDate) : Util.formatDate(Util.subStractDate(new Date(), "add", 1)))
      formik.setFieldValue("metric", props.data.metric)
      formik.setFieldValue("metricCondition", props.data.metricCondition)
      formik.setFieldValue("metricUnit", props.data.metricUnit)
      formik.setFieldValue("metricUnitCustom", props.data.metricUnitCustom)
      formik.setFieldValue("metricValue", props.data.metricValue)
      formik.setFieldValue("isLink", props.data.isLink)

      if (props.data.metricUnitCustom && props.data.metricUnitCustom !== "") {
        selectMetricUnit("custom", { is_custom: true })
      }
      setMetricValue(props.data.metricValue)
      // }
    }
  }, [
    metricConditionListMaster, metricUnitListMaster, metricList,
    props.data.achievementSerial, props.data.name,
    props.data.description, props.data.startDate, props.data.endDate, props.data.metric, props.data.metricCondition,
    props.data.metricUnit, props.data.metricUnitCustom, props.data.metricValue, props.data.isLink
  ])

  useEffect(() => {
    formik.setFieldValue("metricUnitCustom", "")
  }, [formik.values.metricUnit])

  useEffect(() => {
    if (props.type === "edit") {
      // if (formik.values.selectedGoals.length === 0 && formik.values.selectedCompetencies === 0) {
      let isGoalExisted = props.data.selectedGoals.every(element => {
        return goalList.map(goal => goal.serial).indexOf(element) !== -1;
      });
      let isCompetencyExisted = props.data.selectedCompetencies.every(element => {
        return competencyList.map(competency => competency.serial).indexOf(element) !== -1;
      });
      let mergeSelectedGoals = props.data.selectedGoals.concat(formik.values.selectedGoals.filter((item) => props.data.selectedGoals.indexOf(item) < 0))
      let mergeSelectedCompetencies = props.data.selectedCompetencies.concat(formik.values.selectedCompetencies.filter((item) => props.data.selectedCompetencies.indexOf(item) < 0))
      formik.setFieldValue("selectedGoals", isGoalExisted ? mergeSelectedGoals : [])
      formik.setFieldValue("selectedCompetencies", isCompetencyExisted ? mergeSelectedCompetencies : [])
      // }
    }
  }, [
    filteredGoalList, filteredCompetencyList,
    props.data.selectedGoals, props.data.selectedCompetencies
  ])

  useEffect(() => {
    if (currentMetric.hasOwnProperty('serial') && currentMetric.hasOwnProperty('code')) {
      if (currentMetric.code === "accomplishment") {
        setValidationSchema(InitValidationSchema)
        let metricValueList = metricValueListMaster.filter(item => item.serial === currentMetric.serial)
        setMetricValueList(metricValueList)
      } else if (currentMetric.code === "date") {
        let endDate = Util.formatDate(formik.values.endDate)
        setMetricValue(endDate)
        formik.setFieldValue("metricValue", endDate)
        setValidationSchema(InitValidationSchema)
      } else if (currentMetric.code === "value") {
        let valueValidation = yup.number().typeError(t("achievement.label.inputForm.validation.number")).required(t("achievement.label.inputForm.validation.pleaseFillOutThisField"))
        let validation = {
          name: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          description: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          startDate: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          endDate: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metric: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metricUnit: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metricUnitCustom: metricUnitOptions?.is_custom ?? false ? yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")) : yup.string(),
          metricCondition: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metricValue: valueValidation,
        }
        // update validation schema 
        const newValidationSchema = yup.object(validation);
        setValidationSchema(newValidationSchema)
      }
    }
  }, [currentMetric])

  useEffect(() => {
    if (formik.values.metricUnit !== "") {
      if (currentMetric.code === "value") {
        let unitMin = metricUnitOptions?.min ?? 0
        let unitMax = metricUnitOptions?.max ?? 0
        let unitValidation = yup.number().typeError(t("achievement.label.inputForm.validation.pleaseFillOutThisField")).required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")).min(unitMin, t("achievement.label.inputForm.validation.pleaseFillOutThisField"))
        if (unitMax > 0) {
          unitValidation = yup.number().typeError(t("achievement.label.inputForm.validation.pleaseFillOutThisField")).min(unitMin, t("achievement.label.inputForm.validation.pleaseFillOutThisField")).max(unitMax, t("achievement.label.inputForm.validation.pleaseFillOutThisField")).required(t("achievement.label.inputForm.validation.pleaseFillOutThisField"))
        }
        // update validation schema 
        const newValidationSchema = yup.object({
          name: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          description: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          startDate: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          endDate: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metric: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metricUnit: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metricUnitCustom: metricUnitOptions?.is_custom ?? false ? yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")) : yup.string(),
          metricCondition: yup.string().required(t("achievement.label.inputForm.validation.pleaseFillOutThisField")),
          metricValue: unitValidation,
        });
        setValidationSchema(newValidationSchema)
      }
      let metric = metricUnitListMaster.filter(item => item.serial === formik.values.metric)
      let metricUnit = metric && metric.length > 0 ? metric[0].list.filter(item => item.serial === formik.values.metricUnit) : []
      if (!metricUnitOptions?.is_custom) {
        setMetricUnitOptions(metricUnit[0]?.options ?? false ? metricUnit[0]?.options : undefined)
      }
      formik.validateForm()
    }
  }, [formik.values.metricUnit, metricUnitOptions, metricUnitListMaster])

  useEffect(() => {
    formik.validateForm()
  }, [validationSchema, currentMetric, formik.values.metricCondition, formik.values.metricUnit, formik.values.metricUnitCustom, metricValue, formik.values.metricValue, formik.values.name, formik.values.description])

  // check max link
  useEffect(() => {
    let mergeSelected = [...formik.values.selectedGoals, ...formik.values.selectedCompetencies]
    setcurrentSelectedLink(mergeSelected)
    if (formik.values.isLink) {
      if (mergeSelected.length > 0) {
        setIsSelectedLinkValid(true)
      } else if (mergeSelected.length < 1) {
        setIsSelectedLinkValid(false)
      }
    } else if (!formik.values.isLink) {
      setIsSelectedLinkValid(true)
    }
  }, [formik.values.selectedGoals, formik.values.selectedCompetencies, formik.values.isLink])

  // if metric is accomplisment then update metric value
  useEffect(() => {
    if (currentMetric.hasOwnProperty('serial') && currentMetric.hasOwnProperty('code')) {
      if (currentMetric.code === "accomplishment") {
        let tmpMetricValueList = metricValueList.filter(item => item.serial === currentMetric.serial)
        let defaultMetricValue = tmpMetricValueList[0].list.filter(item => item.is_default)
        let tmpMetricValue = []
        if (defaultMetricValue.length > 0) {
          tmpMetricValue = defaultMetricValue[0]
        } else {
          tmpMetricValue = tmpMetricValueList.length > 0 ? tmpMetricValueList[0]?.list[0] ?? {} : {}
        }
        formik.setFieldValue("metricValue", tmpMetricValue.code)
        setMetricValue(tmpMetricValue.name)
      }
    }
  }, [metricValueList])

  const selectDate = (field, data, type) => {
    if (type === "date") {
      formik.setFieldValue(field, Util.formatDate(data))
      if (field === "endDate" && currentMetric.code === "date") {
        setMetricValue(Util.formatDate(data))
        formik.setFieldValue("metricValue", Util.formatDate(data))
      }
    } else {
      formik.setFieldValue(field, data)
    }
  };

  const selectMetric = (value) => {
    if (formik.values.metric !== value) {
      // reset on metric change
      formik.setFieldValue("metricCondition", "")
      formik.setFieldValue("metricUnit", "")
      formik.setFieldValue("metricValue", "")
      setMetricValue("")

      formik.setFieldValue("metric", value)
    }

  };
  const selectMetricCondition = (value, code) => {
    formik.setFieldValue("metricCondition", value)
  };
  const selectMetricUnit = (value, options) => {
    formik.setFieldValue("metricUnit", value)
    setMetricUnitOptions(options)
  };


  const handleChangeMetricValue = (event) => {
    setMetricValue(event.target.value)
    formik.setFieldValue("metricValue", event.target.value)
  }

  const handleCheckIsLink = () => {
    formik.setFieldValue("isLink", !formik.values.isLink)
  };

  const handleGoalSelected = (value) => {
    let tmpGoalSelected = [...formik.values.selectedGoals]
    let isExists = tmpGoalSelected.indexOf(value)
    if (isExists > -1) {
      tmpGoalSelected = tmpGoalSelected.filter(item => item !== value)
    } else {
      tmpGoalSelected.push(value)
    }
    formik.setFieldValue("selectedGoals", tmpGoalSelected)
  };
  const handleCompetencySelected = (value) => {
    let tmpCompetencySelected = [...formik.values.selectedCompetencies]
    let isExists = tmpCompetencySelected.indexOf(value)
    if (isExists > -1) {
      tmpCompetencySelected = tmpCompetencySelected.filter(item => item !== value)
    } else {
      tmpCompetencySelected.push(value)
    }
    formik.setFieldValue("selectedCompetencies", tmpCompetencySelected)
  };

  const handleSearchGoal = (event) => {
    setSearchGoalValue(event.target.value);
  };

  const handleSearchCompetency = (event) => {
    setSearchCompetencyValue(event.target.value);
  };

  const handleSubmit = () => {
    if (isSelectedLinkValid) {
      formik.submitForm()
    }
  }

  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      fontWeight: 300
    }
  }
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  return (
    <Box sx={{ padding: "24px 24px 0 24px" }}>
      <Grid container>
        <Grid item xs>
          <Typography variant="h4" color="#404349">{t("achievement.label.achievementDetail")}</Typography>
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.achievementName")}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
        </Grid>
      </Grid>
      <Grid container mb={1}>
        <Grid item xs classes={{ root: classes["error"] }}>
          <TextField
            margin="dense"
            id="name"
            fullWidth
            sx={{ marginTop: "10px", marginBottom: 0 }}
            size="small"
            value={formik.values.name}
            placeholder={t("achievement.label.inputForm.enterName")}
            onChange={formik.handleChange}
            helperText={formik.touched.name && formik.errors.name}
            error={Boolean(formik.touched.name && formik.errors.name)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.achievementDetail")}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
        </Grid>
      </Grid>
      <Grid container mb={1}>
        <Grid item xs classes={{ root: classes["error"] }}>
          <TextField
            multiline
            rows={4}
            margin="dense"
            id="description"
            style={{ whiteSpace: "pre-line" }}
            type="email"
            fullWidth
            sx={{ marginTop: "10px", marginBottom: 0 }}
            placeholder={t("achievement.label.inputForm.enterDetail")}
            size="small"
            value={formik.values.description}
            onChange={formik.handleChange}
            helperText={formik.touched.description && formik.errors.description}
            error={Boolean(formik.touched.description && formik.errors.description)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6} md={6}>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.achievementStartDate")}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}>*</Box></Typography>
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.achievementEndDate")}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}>*</Box></Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} mb={1}>
        <Grid item xs={6} sm={6} md={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              format="dd/MM/yyyy"
              value={formik.values.startDate}
              maxDate={maxDate}
              disabled={false}
              onChange={(newValue) => {
                selectDate('startDate', newValue, "date");
              }}
              inputProps={{ placeholder: t("achievement.label.inputForm.selectStartDate") }}
              renderInput={(params) => <TextField {...params}
                fullWidth
                size="small"
                sx={{ pt: 1 }}
              />
              }
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={6} sm={6} md={6} mb={1}>
          <LocalizationProvider dateAdapter={AdapterDateFns} >
            <DesktopDatePicker
              format="dd/MM/yyyy"
              value={formik.values.endDate}
              maxDate={maxEndDate}
              disabled={false}
              onChange={(newValue) => {
                selectDate('endDate', newValue, "date");
              }}
              inputProps={{ placeholder: t("achievement.label.inputForm.selectEndDate") }}
              renderInput={(params) => <TextField {...params}
                fullWidth
                size="small"
                sx={{ pt: 1 }}
              />
              }
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6} md={6}>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.achievementMetric")}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color={metricConditionList.length === 0 ? "#BABABA" : "#404349"}>{t("achievement.label.inputForm.achievementTargetCondition")}{metricConditionList.length > 0 ? (<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}>*</Box>) : null}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} mb={1}>
        <Grid item classes={{ root: classes["error"] }} xs={6} sm={6} md={6}>
          <Select
            id="metric-select"
            variant="outlined"
            defaultValue=""
            displayEmpty
            size="small"
            fullWidth
            className="white-bg"
            value={formik.values.metric || ""}
            sx={Boolean(formik.touched.metric && formik.errors.metric) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
          >
            <MenuItem disabled value="">
              <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("achievement.label.inputForm.selectMetric")} </Typography>
            </MenuItem>
            {
              metricList?.length > 0 ?
                metricList.map(item => {
                  return (
                    <MenuItem value={item.serial} key={item.name} onClick={() => selectMetric(item.serial)}>
                      {item.name}
                    </MenuItem>
                  )
                })
                : null
            }
          </Select>
          {formik.touched.metric && formik.errors.metric ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.metric} </FormHelperText>) : <></>}
        </Grid>
        <Grid item classes={{ root: classes["error"] }} xs={6}>
          <Select
            id="condition-select"
            variant="outlined"
            defaultValue=""
            displayEmpty
            size="small"
            fullWidth
            classes={metricConditionList.length === 0 ? { select: classes.disabled } : {}}
            value={formik.values.metricCondition || ""}
            sx={Boolean(formik.touched.metricCondition && formik.errors.metricCondition) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
            disabled={metricConditionList.length === 0}
          >
            {
              metricConditionList.length > 0 ?
                (<MenuItem disabled value="">
                  <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("achievement.label.inputForm.selectTargetCondition")}</Typography>
                </MenuItem>) : null
            }
            {
              metricConditionList?.length > 0 ?
                metricConditionList.map(item => {
                  return (
                    <MenuItem value={item.value} key={item.name} onClick={() => selectMetricCondition(item.value)}>
                      {item.name}
                    </MenuItem>
                  )
                })
                : null
            }
          </Select>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6} md={6}>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color={metricConditionList.length === 0 ? "#BABABA" : "#404349"}>{t("achievement.label.inputForm.achievementUnit")}{metricConditionList.length > 0 ? (<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}>*</Box>) : null}</Typography>
        </Grid>
        <Grid item xs={6} sm={6} md={6} sx={{ display: "flex" }}>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.achievementTargetValue")}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}>*</Box></Typography>
          <Typography variant="sub_label" fontSize={18} lineHeight="24px" display="flex" sx={{ ml: "auto" }}>
            {
              metricUnitOptions?.min !== undefined && metricUnitOptions?.max !== undefined ? `${metricUnitOptions.min.toLocaleString()} - ${metricUnitOptions.max.toLocaleString()}` : ""
            }
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item classes={{ root: classes["error"] }} xs={6} sm={6} md={6}>
          <Select
            id="unit-select"
            variant="outlined"
            defaultValue=""
            displayEmpty
            size="small"
            fullWidth
            className="white-bg"
            classes={metricUnitList.length === 0 ? { select: classes.disabled } : {}}
            value={formik.values.metricUnit || ""}
            sx={Boolean(formik.touched.metricUnit && formik.errors.metricUnit) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
            disabled={metricUnitList.length === 0}
          >
            {
              metricUnitList.length > 0 ?
                (<MenuItem disabled value="">
                  <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("achievement.label.inputForm.selectUnit")}</Typography>
                </MenuItem>) : null
            }
            {
              metricUnitList?.length > 0 ?
                metricUnitList.map(item => {
                  return (
                    <MenuItem value={item.serial} key={item.name} onClick={() => selectMetricUnit(item.serial, item.options)}>
                      {item.name}
                    </MenuItem>
                  )
                })
                : null
            }
            {/* custom */}
            <MenuItem key="custom-unit-selected" value="custom" onClick={() => selectMetricUnit("custom", { is_custom: true })}>{t("achievement.label.inputForm.custom")}</MenuItem>
          </Select>
        </Grid>
        <Grid item classes={{ root: classes["error"] }} xs={6} sm={6} md={6}>
          <TextField
            margin="dense"
            id="metricValue"
            fullWidth
            sx={{ marginTop: "10px", marginBottom: 0 }}
            classes={currentMetric?.code === "accomplishment" || currentMetric?.code === "date" || formik.values.metric === "" ? { root: classes.softDisabled } : null}
            size="small"
            value={currentMetric?.code !== "date" ? currentMetric.code === "accomplishment" && metricValue ? Util.capitalizedString(metricValue) : metricValue : Util.formatDate2(metricValue)}
            onChange={handleChangeMetricValue}
            helperText={formik.touched.metricValue && formik.errors.metricValue}
            error={Boolean(formik.touched.metricValue && formik.errors.metricValue)}
            disabled={currentMetric?.code === "accomplishment" || currentMetric?.code === "date" || formik.values.metric === ""}
            placeholder={currentMetric?.code === "value" ? t("achievement.label.inputForm.fillInTargetValue") : ""}
          />
        </Grid>
      </Grid>
      {
        formik.values.metricUnit === "custom" &&
        (<Grid container spacing={3} mb={3}>
          <Grid item xs={6} sm={6} md={6}>
            <Grid container spacing={1}>
              <Grid item xs={3.5} sm={3.5} md={3.5} display="flex" alignItems="center">
                <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.pleaseSpecify")} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}>*</Box></Typography>
              </Grid>
              <Grid item xs sm md>
                <TextField
                  margin="dense"
                  id="metricUnitCustom"
                  fullWidth
                  sx={{ marginTop: "10px", marginBottom: 0 }}
                  size="small"
                  placeholder={t("achievement.label.pleaseSpecify")}
                  value={formik.values.metricUnitCustom}
                  onChange={formik.handleChange}
                  helperText={formik.touched.metricUnitCustom && formik.errors.metricUnitCustom}
                  error={Boolean(formik.touched.metricUnitCustom && formik.errors.metricUnitCustom)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>)
      }
      <Grid container spacing={3}>
        <Grid item xs sm md>
          <Typography variant="subtitle2" fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.achievementIsLink")}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item display="flex" alignItems="center">
          <Checkbox {...label} color="primary" sx={{ pl: 0 }} checked={formik.values.isLink} onChange={handleCheckIsLink} />
          <Typography color="#404349"> {t("label.yes")} </Typography>
        </Grid>
      </Grid>
      {
        formik.values.isLink ?
          <React.Fragment>
            <Grid container spacing={0} mt={1}>
              <Grid item xs sm md display="flex">
                <Typography fontWeight={600} fontSize={16} display="flex" color="primary">{t("achievement.label.inputForm.linkAssociateDesc")} {maxLink} {t("achievement.label.inputForm.linkAssociateDesc2")}</Typography>
              </Grid>
            </Grid>
            <Grid container mt={1}>
              <Grid item xs sm md display="flex">
                <Typography fontWeight={600} fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.goalLists")}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item display="flex" alignItems="center" xs sm md>
                <Box sx={{
                  width: "100%",
                  borderRadius: "4px",
                  p: 2,
                  mt: 1
                }}
                  border={isSelectedLinkValid ? "1px solid #D4D9DE" : "1px solid #CC6058"}
                >
                  <Box sx={{
                    width: "100%",
                    height: "225px",
                    overflowY: "auto",
                    p: 1,
                    '&::-webkit-scrollbar': {
                      width: "6px",
                      backgroundColor: "#5DA196",
                      borderRadius: "10px",
                    },
                    '&::-webkit-scrollbar-track': {
                      WebkitBoxShadow: "none",
                      borderRadius: "10px",
                      backgroundColor: "#EFEFEF"
                    },
                    '&::-webkit-scrollbar-thumb': {
                      borderRadius: "10px",
                      WebkitBoxShadow: "none",
                      backgroundColor: "#5DA196",
                    }
                  }}>
                    <TextField
                      fullWidth
                      id="input-with-icon-textfield"
                      placeholder={t("achievement.label.searchGoals")}
                      size="small"
                      sx={{ background: "#fff", height: "40px" }}
                      className="searchTextField-h48"
                      value={searchGoal}
                      onChange={handleSearchGoal}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search style={{ color: "#C4C4C4" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {
                      filteredGoalList?.length > 0 ?
                        filteredGoalList.map((item, index) =>
                        (
                          <Grid container spacing={0} key={item.serial} mb="8px" mt={index === 0 ? 1 : 0}>
                            <Grid item display="flex" alignItems="top" sx={{ ".MuiTypography-root": { color: "#404349" } }}>
                              <FormControlLabel control={
                                <Checkbox checked={formik.values.selectedGoals.includes(item.serial)} onChange={() => handleGoalSelected(item.serial)} classes={{ root: classes.checkboxRoot }} />} label={item.name}
                                disabled={
                                  currentSelectedLink.length >= maxLink && !currentSelectedLink.includes(item.serial) ? true : false
                                }
                                classes={{ root: classes.formControlRoot }}
                              />
                            </Grid>
                          </Grid>)
                        )
                        : null
                    }
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={3} mt={1}>
              <Grid item xs sm md display="flex">
                <Typography fontWeight={600} fontSize={18} lineHeight="24px" display="flex" color="#404349">{t("achievement.label.inputForm.competencyLists")}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item display="flex" alignItems="center" xs sm md>
                <Box sx={{
                  width: "100%",
                  borderRadius: "4px",
                  p: 2,
                  mt: 1
                }}
                  border={isSelectedLinkValid ? "1px solid #D4D9DE" : "1px solid #CC6058"}
                >
                  <Box sx={{
                    width: "100%",
                    height: "225px",
                    overflowY: "auto",
                    p: 1,
                    '&::-webkit-scrollbar': {
                      width: "6px",
                      backgroundColor: "#5DA196",
                      borderRadius: "10px",
                    },
                    '&::-webkit-scrollbar-track': {
                      WebkitBoxShadow: "none",
                      borderRadius: "10px",
                      backgroundColor: "#EFEFEF"
                    },
                    '&::-webkit-scrollbar-thumb': {
                      borderRadius: "10px",
                      WebkitBoxShadow: "none",
                      backgroundColor: "#5DA196",
                    }
                  }}>
                    <TextField
                      fullWidth
                      id="input-with-icon-textfield"
                      placeholder={t("achievement.label.searchCompetencies")}
                      size="small"
                      sx={{ background: "#fff", height: "40px" }}
                      className="searchTextField-h48"
                      value={searchCompetency}
                      onChange={handleSearchCompetency}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search style={{ color: "#C4C4C4" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {
                      filteredCompetencyList?.length > 0 ?
                        filteredCompetencyList.map((item, index) =>
                        (
                          <Grid container spacing={0} key={item.serial} mb="8px" mt={index === 0 ? 1 : 0}>
                            <Grid item display="flex" alignItems="center" sx={{ ".MuiTypography-root": { color: "#404349" } }}>
                              <FormControlLabel control={<Checkbox checked={formik.values.selectedCompetencies.includes(item.serial)} onChange={() => handleCompetencySelected(item.serial)} classes={{ root: classes.checkboxRoot }} />} label={item.code + ' - ' + item.name}
                                disabled={
                                  currentSelectedLink.length >= maxLink && !currentSelectedLink.includes(item.serial) ? true : false
                                }
                                classes={{ root: classes.formControlRoot }}
                              />
                            </Grid>
                          </Grid>)
                        )
                        : null
                    }
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item>
                {!isSelectedLinkValid ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}> {t("achievement.label.inputForm.validation.pleaseSelectLink")} </FormHelperText>) : <></>}
              </Grid>
            </Grid>

          </React.Fragment> : null
      }
      {/* action buttons */}
      <Grid container mt={3} mb={0} classes={{ root: classes.footer }}>
        <Grid item xs display="flex" flexDirection="row-reverse">
          <Box sx={{ width: "100px" }}>
            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
              {props.type === "add" ? t("label.add") : t("label.save")}
            </Button>
          </Box>
          <Box mr={2} sx={{ width: "100px" }}>
            <Button onClick={() => props.close(formik.values)} color="black" variant="outlined" fullWidth sx={{ textTransform: "none" }}>
              {t("label.cancel")}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default InputForm;
